import { Sparkles } from "lucide-react";
import { PortfolioCard } from "@/components/site/PortfolioCard";
import { CtaBanner, PageHeader } from "@/components/site/SiteLayout";
import { usePublicPortfolio } from "@/hooks/usePublicPortfolio";

const Skeletons = () => (
  <div className="grid gap-6 md:grid-cols-2 md:gap-8 lg:grid-cols-3">
    {[0, 1, 2].map((i) => <div key={i} className="h-96 animate-pulse rounded-2xl bg-white/[0.03]" />)}
  </div>
);

const Empty = () => (
  <div data-testid="portfolio-empty-state" className="relative mx-auto max-w-xl overflow-hidden rounded-2xl border border-dashed border-cyan-400/25 bg-[#0B111D] px-6 py-16 text-center">
    <div className="glow-orb pulse-glow absolute left-1/2 top-0 h-56 w-56 -translate-x-1/2" />
    <Sparkles className="relative mx-auto h-8 w-8 text-cyan-300" />
    <h2 className="relative mt-5 text-2xl font-bold text-white">New projects coming soon</h2>
    <p className="relative mt-3 text-sm text-slate-400">We're polishing our next launches. Check back shortly.</p>
  </div>
);

export default function Portfolio() {
  const { items } = usePublicPortfolio();
  return (
    <div data-testid="portfolio-page">
      <PageHeader eyebrow="// portfolio" title="Websites we own and operate." testId="portfolio-title">
        These are our own properties: built, hosted, optimized and monetized in-house. They are where we prove out every technique before we use it on client work.
      </PageHeader>
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 md:py-24 lg:px-12">
        {items === null ? <Skeletons /> : items.length === 0 ? <Empty /> : (
          <div data-testid="portfolio-grid" className="grid gap-6 md:grid-cols-2 md:gap-8 lg:grid-cols-3">
            {items.map((it, i) => <PortfolioCard key={it.id} item={it} index={i} />)}
          </div>
        )}
      </section>
      <CtaBanner />
    </div>
  );
}
